const FIVE_MINUTES = 5 * 60000;
export const OPEN_CHALLENGE_POLL_DURATION = 60000; // 60000
export const LIVE_CHALLENGE_POLL_DURATION = 30000; // 30000
export const LIVE_TEAM_POLL_DURATION = 40000; // 40000
export const NOTIFICATIONS_POLL_DURATION = FIVE_MINUTES; // FIVE_MINUTES
export const USER_POLL_DURATION = FIVE_MINUTES; // FIVE_MINUTES
export const JACKPOT_SLOTS_POLL_DURATION = FIVE_MINUTES; // FIVE_MINUTES
